import { lighten } from 'polished';
import { defaultColors } from './thems/default';

import { theme as nybyggDarkOld } from './thems/nybygg_dark_old';
import { theme as nybyggLightOld } from './thems/nybygg_light_old';

export type ThemeName = 'nybyggDarkOld' | 'nybyggLightOld' | '';

const sizes = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

const devices = {
  mobileS: `(min-width: ${sizes.mobileS})`,
  mobileM: `(min-width: ${sizes.mobileM})`,
  mobileL: `(min-width: ${sizes.mobileL})`,
  tablet: `(min-width: ${sizes.tablet})`,
  laptop: `(min-width: ${sizes.laptop})`,
  laptopL: `(min-width: ${sizes.laptopL})`,
  desktop: `(min-width: ${sizes.desktop})`,
  desktopL: `(min-width: ${sizes.desktop})`,
};

const colors = {
  primary: '#e8c893',
  primaryLight: lighten(0.1, '#e8c893'),
};

export const common = {
  defaultColors,
  sizes,
  devices,
  colors,
};

export const theme = {
  nybyggDarkOld: { ...nybyggDarkOld, ...common },
  nybyggLightOld: { ...nybyggLightOld, ...common },
} as { [key: string]: any };

type Theme = typeof theme;
declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}
